import styled from '@emotion/styled';
import { ButtonWithIcon } from '@zoopla/blueprint-button-with-icon';
import { css } from '@emotion/react';
import { FiltersLabel } from '@zoopla/listing-search/filters/modal';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { Radio } from '@blueprint/ui';

const MOBILE_SECTION_HEADLINE_MARGIN_BOTTOM = '12px';
const MOBILE_SECTION_RADIO_TOP = '2px';

export const StyledDropdown = styled.select(
    ({ theme: { colors, type } }) => css`
        border: 0;
        color: ${colors['primary-brand']};
        font-weight: ${type.semiBold};
        font-size: 1rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
        font-family: inherit;
        text-align-last: right;
        background-color: ${colors.white};
    `
);

type StyledButtonProps = {
    isDisabled?: boolean;
};

export const UpdateButtonWithIcon = styled(ButtonWithIcon)<StyledButtonProps>(
    (props) => {
        const {
            isDisabled = false,
            theme: { spacing }
        } = props;
        return css`
            opacity: ${isDisabled ? 0.4 : 1};
            cursor: ${isDisabled ? 'default' : 'pointer'};
            line-height: ${spacing['24px']};
            border: none;
        `;
    }
);

export const StyledLabel = styled('p')(
    ({ theme }) => css`
        margin: 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.body};
        color: ${theme.colors['text-body']};
        font-weight: ${theme.type.semiBold};
    `
);

export const Wrapper = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: space-between;
        padding: ${spacing['16px']} 0;
    `
);

export const FilterWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0;
        width: 100%;
        padding-bottom: ${spacing['16px']};
    `
);

export const MobileSectionHeadline = styled('p')(
    ({ theme: { fontSizes, type, colors } }) => css`
        margin: 0 0 ${MOBILE_SECTION_HEADLINE_MARGIN_BOTTOM} 0;
        color: ${colors['text-body']};
        font-weight: ${type.semiBold};
        display: flex;
        align-self: flex-start;
        font-size: ${fontSizes['1']};
        line-height: ${fontSizes['2']};
    `
);

export const LocationFilterWrapper = styled(FilterWrapper)(
    ({ theme: { spacing, fontSizes, type } }) => {
        return css`
            margin-top: ${spacing['16px']};
            padding-bottom: ${spacing['16px']};
            z-index: 4;
            position: relative;
            line-height: ${fontSizes['7']};

            input {
                height: 56px;
            }

            input::placeholder {
                font-weight: ${type.normal};
                line-height: ${fontSizes['7']};
            }

            p {
                line-height: ${fontSizes['2']};
            }
        `;
    }
);

export const PropertyTypeRadio = styled.div(
    () => css`
        width: 50%;
        z-index: 0;
    `
);

export const StyledFiltersModal = styled.div(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['16px']};
    `
);

export const RadiusDropdownWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-top: ${spacing['24px']};
    `
);

export const SelectedPropertyTypeWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['24px']};
    `
);

export const PropertyTypeFilterLabel = styled(FiltersLabel)(
    ({ theme: { fontSizes, type } }) => css`
        margin-top: 0;
        font-size: ${fontSizes['1']};
        font-weight: ${type.semiBold};
        line-height: ${fontSizes['2']};
        padding-bottom: ${MOBILE_SECTION_HEADLINE_MARGIN_BOTTOM};
    `
);

export const StyledDropdownWithLabel = styled(DropdownWithLabel)(
    ({ theme: { fontSizes, type } }) => css`
        line-height: ${fontSizes['7']};
        font-weight: ${type.semiBold};
        height: 56px;

        + p {
            font-weight: ${type.semiBold};
            line-height: ${fontSizes['2']};
        }
    `
);

export const StyledRadio = styled(Radio)(
    ({ theme: { fontSizes, type } }) => css`
        line-height: ${fontSizes['7']};
        top: ${MOBILE_SECTION_RADIO_TOP};

        + label {
            line-height: ${fontSizes['7']};
            font-weight: ${type.normal};
        }

        + label::before {
            top: ${MOBILE_SECTION_RADIO_TOP};
        }

        :focus + label::after {
            top: ${MOBILE_SECTION_RADIO_TOP};
        }
    `
);
